module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  })]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('div', [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_c('p', {
    staticClass: "ct"
  })]), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Capital_Crimes#toc_marker-1"
    }
  }, [_vm._v("Capital Crimes")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes1#toc_marker-2"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes3#toc_marker-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes4#toc_marker-5"
    }
  }, [_vm._v("The Case of Lady Sannox")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes5#toc_marker-6"
    }
  }, [_vm._v("A Mystery of the Underground")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes6#toc_marker-7"
    }
  }, [_vm._v("The Finchley Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes7#toc_marker-8"
    }
  }, [_vm._v("The Magic Casket")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes8#toc_marker-9"
    }
  }, [_vm._v("The Holloway Flat Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes9#toc_marker-10"
    }
  }, [_vm._v("The Magician of Cannon Street")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes10#toc_marker-11"
    }
  }, [_vm._v("The Stealer of Marble")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes11#toc_marker-12"
    }
  }, [_vm._v("The Tea Leaf")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes12#toc_marker-13"
    }
  }, [_vm._v("The Hands of Mr Ottermole")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes13#toc_marker-14"
    }
  }, [_vm._v("The Little House")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes14#toc_marker-15"
    }
  }, [_vm._v("The Silver Mask")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes15#toc_marker-16"
    }
  }, [_vm._v("Wind in the East")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes16#toc_marker-17"
    }
  }, [_vm._v("The Avenging Chance")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes17#toc_marker-18"
    }
  }, [_vm._v("They Don’t Wear Labels")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes18#toc_marker-19"
    }
  }, [_vm._v("The Unseen Door")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes19#toc_marker-20"
    }
  }, [_vm._v("Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes20#toc_marker-21"
    }
  }, [_vm._v("You Can’t Hang Twice")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes21#toc_marker-22"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Capital_Crimes22#toc_marker-23"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e3edb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Capital_Crimes-2.vue
// module id = 63
// module chunks = 0